import { gql } from "@apollo/client";

export const NEARBY_SUPS_QUERY = gql`
	query GetNearbySUPs(
		$latitude: String!
		$longitude: String!
		$type: String!
		$unitId: String
		$limit: Int
		$searchAfter: String
		$searchBefore: String
		$excludeId: String
	) {
		sellerUnitsAndProjects(
			params: {
				getNearby: {
					latitude: $latitude
					longitude: $longitude
					type: $type
					unitId: $unitId
					limit: $limit
					searchAfter: $searchAfter
					searchBefore: $searchBefore
					excludeId: $excludeId
				}
			}
		) {
			getNearby {
				data {
					_id
					bedrooms
					bathrooms
					builtUpAreas
					cover
					distance
					localityName
					prices
					projectId
					projectName
					parkings
					slug
					type
					updatedAt
					_score
				}
				hasMore
				searchAfter
				searchBefore
				total
			}
		}
	}
`;
